// Finance build — query-key factory for the loan Income & Outflow read surface.
// Array-literal query keys live ONLY in *Keys.ts files (stale-after-save
// convention); the hook in useIncomeLedger imports this.

export const incomeLedgerKeys = {
  loan: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "income-ledger"] as const,
};
